export default {
    'efaktura-list': '/velg-efaktura',
    'choose-person': '/velg-person',
    summary: '/oppsummering',
    update: '/oppdater-deling',
    cancel: '#/',
    home: '/',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicm91dGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3dpZGdldHMvRWZha3R1cmFTaGFyaW5nL3JvdXRlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxlQUFlO0lBQ1gsZUFBZSxFQUFFLGdCQUFnQjtJQUNqQyxlQUFlLEVBQUUsY0FBYztJQUMvQixPQUFPLEVBQUUsZUFBZTtJQUN4QixNQUFNLEVBQUUsa0JBQWtCO0lBQzFCLE1BQU0sRUFBRSxJQUFJO0lBQ1osSUFBSSxFQUFFLEdBQUc7Q0FDWixDQUFDIn0=